import {usePanel} from '../app/PanelProvider.js';
import {ContentQueue} from '../features/today/ContentQueue.js';
import {RegenerationBanner} from '../features/today/RegenerationBanner.js';
import {ReviewPanel} from '../features/today/ReviewPanel.js';
import {StatGrid} from '../features/today/StatGrid.js';
import {useTodayDashboard} from '../features/today/useTodayDashboard.js';

export const TodayPage = () => {
  const state = useTodayDashboard();
  const {regeneracao, atualizarAgora} = usePanel();
  if (!state) {
    return null;
  }

  const {
    today,
    selected,
    select,
    changeBoxOpen,
    openChangeBox,
    closeChangeBox,
  } = state;

  return (
    <>
      {/*
        O ALERTA DO DIA, antes de tudo.
 
        Ele não é de peça nenhuma: o primeiro caso é `NO_FRESH_NEWS`, em que a
        peça de foto NÃO existe porque não houve notícia fresca. Sem ele, o dono
        contaria seis cartões em vez de sete e não teria como distinguir "não
        houve notícia" de "a esteira quebrou".
 
        A mensagem vem do SERVIDOR, e a tela não a monta a partir do código: um
        mapa de código para texto aqui ficaria para trás no dia em que um código
        novo nascesse, e o alerta apareceria em branco.
      */}
      {today.alerts.map((alerta) => (
        <div className="dm-alert" role="alert" key={alerta.code}>
          {alerta.message}
        </div>
      ))}
      {/*
        A REGENERAÇÃO em curso, quando há uma.

        Ela fica acima do resumo porque é a única coisa da tela que está
        acontecendo AGORA. Até 2026-09-06 nada aparecia aqui: a peça saía da
        fila, um toast prometia o retorno e a aba ficava parada (achado F12).
      */}
      <RegenerationBanner
        regeneracao={regeneracao}
        onAtualizar={atualizarAgora}
      />
      <StatGrid counters={today.counters} nextSlot={today.nextSlot} />
      <div className="dm-workspace">
        <ContentQueue
          pieces={today.queue}
          operationDate={today.date}
          selectedId={selected.contentVersionId}
          onSelect={select}
        />
        <ReviewPanel
          piece={selected}
          changeBoxOpen={changeBoxOpen}
          onOpenChangeBox={openChangeBox}
          onCloseChangeBox={closeChangeBox}
        />
      </div>
    </>
  );
};
